import React, { useEffect, useState } from "react";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Box,
  Button,
  TextField,
  Grid,
  Paper,
  Card,
  CardContent,
  Collapse,
} from "@mui/material";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIcon from "@mui/icons-material/Assignment";
import DashboardIcon from "@mui/icons-material/Dashboard";
export const PatientUserDashboard = () => {
  const [categories, setCategories] = useState([]);
  const [expandedCategoryId, setExpandedCategoryId] = useState(null); // Track which category is expanded
  const navigate = useNavigate();

  const userDataString = localStorage.getItem("Login_User_Community_All_Data");
  const userData = JSON.parse(userDataString);
  const token = userData.token;
  const roleId = userData.role;
  const [latestPostFives, setLatestFivePosts] = useState([]);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchCategories = async () => {
      const roleId = userData.role;
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/getCategoriesByRoleId/${roleId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Pass the token for authenticated API calls
            },
          }
        );
        setCategories(response.data); // Assuming response.data is an array of categories
      } catch (error) {
        console.error("Error fetching categories:", error.message);
      }
    };

    fetchCategories();
  }, []);

  // Toggle category expansion
  const handleToggle = (categoryId) => {
    setExpandedCategoryId((prevId) =>
      prevId === categoryId ? null : categoryId
    );
  };

  // Navigate to the corresponding posts of a subcategory
  const handleSubcategoryClick = (subcategoryId) => {
    navigate(`/patient-user/sub-category/${subcategoryId}`);
  };

  const handleClick = () => {
    navigate("/patient-user/create-post");
  };

  const [communityStats, setCommunityStats] = useState([
    { title: "Total Members", value: "0", icon: <GroupIcon /> },
    {
      title: "Active Category(SubCategory)",
      value: "11(25)",
      icon: <AssignmentIcon />,
    },
    { title: "Total Post", value: "5", icon: <DashboardIcon /> },
  ]);

  useEffect(() => {
    // Fetch Total Members Count
    const fetchTotalMembersCount = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/get-approval-user-count`
        );
        const totalMembers = response.data.approval_user_count;

        setCommunityStats((prevStats) =>
          prevStats.map((stat) =>
            stat.title === "Total Members"
              ? { ...stat, value: totalMembers }
              : stat
          )
        );
      } catch (error) {
        console.error("Error fetching total members:", error);
      }
    };

    // Fetch Category and Subcategory Count
    const fetchCategoryAndSubCategoryCount = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/get-category-subcategory-count`
        );
        const { category_count, subcategory_count } = response.data;

        // Update the "Active Category(SubCategory)" value in communityStats
        setCommunityStats((prevStats) =>
          prevStats.map((stat) =>
            stat.title === "Active Category(SubCategory)"
              ? { ...stat, value: `${category_count}(${subcategory_count})` }
              : stat
          )
        );
      } catch (error) {
        console.error("Error fetching category and subcategory counts:", error);
      }
    };

    const fetchTotalPostCount = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/get-total-post-count`
        );
        const { post_count } = response.data;

        // Update the "Active Category(SubCategory)" value in communityStats
        setCommunityStats((prevStats) =>
          prevStats.map((stat) =>
            stat.title === "Total Post"
              ? { ...stat, value: `${post_count}` }
              : stat
          )
        );
      } catch (error) {
        console.error("Error fetching post counts:", error);
      }
    };

    const fetchLatestFivePosts = async () => {
      try {
        const response = await axios.get(
          `${API_BASE_URL}/api/get-latest-post`
        );

        setLatestFivePosts(response.data);
      } catch (error) {
        console.error("Error fetching latest posts:", error);
      }
    };

    fetchTotalMembersCount();
    fetchCategoryAndSubCategoryCount();
    fetchTotalPostCount();
    fetchLatestFivePosts();
  }, []);

  const handleNavigate = (pryid) => {
    if (roleId == "3") {
      navigate(`/provider-user/post-details/${pryid}`);
    } else if (roleId == "2") {
      navigate(`/patient-user/post-details/${pryid}`);
    } else if (roleId == "1") {
      navigate(`/admin-user/post-details/${pryid}`);
    } else if (roleId == "4") {
      navigate(`/vendor-user/post-details/${pryid}`);
    } else {
      navigate(`/admin-user/post-details/${pryid}`);
    }
  };
  return (
    <Box sx={{ padding: 3 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "20px",
        }}
      >
        {(roleId === "3" || roleId === "1" || roleId === "4") && (
          <Button
            style={{
              backgroundColor: "#007bff", // Primary blue color
              color: "#fff",
              padding: "10px 20px",
              borderRadius: "8px",
              fontSize: "16px",
              fontWeight: "bold",
              textTransform: "none",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)", // Slight shadow for depth
            }}
            onClick={handleClick}
          >
            Create New Topic
          </Button>
        )}
      </div>
      <Grid container spacing={3}>
        {communityStats.map((stat, index) => (
          <Grid item xs={12} sm={4} key={index}>
            <Card sx={{ boxShadow: 3 }}>
              <CardContent>
                <Box display="flex" alignItems="center">
                  {stat.icon}
                  <Typography
                    variant="h6"
                    component="div"
                    sx={{ marginLeft: "10px" }}
                  >
                    {stat.title}
                  </Typography>
                </Box>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{ textAlign: "center", marginTop: "15px" }}
                >
                  {stat.value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <br></br>

      <Grid container spacing={4}>
        {/* Left Column: Categories */}
        <Grid item xs={12} md={8}>
          <Typography
            variant="h5"
            sx={{
              backgroundColor: "#2196f3",
              textAlign: "center",
              color: "#fff",
              padding: "8px 0",
            }}
            gutterBottom
          >
            Categories
          </Typography>
          {categories.map((category) => (
            <Card key={category.id} sx={{ marginBottom: 2 }}>
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  onClick={() => handleToggle(category.id)}
                  sx={{ cursor: "pointer" }}
                >
                  <Typography variant="h6">{category.name}</Typography>
                  {expandedCategoryId === category.id ? (
                    <ExpandLessIcon />
                  ) : (
                    <ExpandMoreIcon />
                  )}
                </Box>

                <Collapse in={expandedCategoryId === category.id}>
                  <Box sx={{ marginTop: 2, paddingLeft: 2 }}>
                    {category.subcategories &&
                    category.subcategories.length > 0 ? (
                      category.subcategories.map((subcategory) => (
                        <Button
                          key={subcategory.id}
                          variant="outlined"
                          sx={{ marginBottom: 1, marginRight: 1 }}
                          onClick={() => handleSubcategoryClick(subcategory.id)}
                        >
                          {subcategory.name}
                        </Button>
                      ))
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        No subcategories available.
                      </Typography>
                    )}
                  </Box>
                </Collapse>
              </CardContent>
            </Card>
          ))}
        </Grid>

        {/* Right Column: Latest Posts */}
        <Grid item xs={12} md={4}>
          <Typography
            variant="h5"
            sx={{
              backgroundColor: "#2196f3",
              textAlign: "center",
              color: "#fff",
              padding: "8px 0",
            }}
            gutterBottom
          >
            Latest Posts
          </Typography>
          {latestPostFives.length > 0 ? (
            latestPostFives.map((post) => (
              <Card key={post.id} sx={{ marginBottom: 2 }}>
                <CardContent>
                  <Typography
                    variant="h6"
                    sx={{ cursor: "pointer", color: "blue" }}
                    onClick={() => handleNavigate(post.id)}
                  >
                    {post.title}
                  </Typography>
                </CardContent>
              </Card>
            ))
          ) : (
            <Typography variant="body2" color="text.secondary">
              No posts available.
            </Typography>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
